import type { RouteRecordRaw } from 'vue-router';

const InfluencersPage = () => import('@/views/influencers/InfluencersPage.vue');
const InfluencerDetailsPage = () => import('@/views/influencers/influencer-details/InfluencerDetailsPage.vue');
const InfluencerComparisonPage = () => import('@/views/influencers/influencer-details/InfluencerComparisonPage.vue');

export const influencerRoutes: RouteRecordRaw[] = [
  {
    path: '/influencers',
    name: 'influencers',
    component: InfluencersPage,
  },
  {
    path: '/influencers/:influencer_id',
    name: 'influencer-details',
    component: InfluencerDetailsPage,
  },
  {
    path: '/influencers-comparison/:influencer_id',
    name: 'influencer-comparison',
    component: InfluencerComparisonPage,
  },
];
